import React from "react"
import { Helmet } from "react-helmet"

import OfferBase from "../../../components/offer"

const Offer = () => {
  return (
    <OfferBase offerTitle={'Konsultacja dermatologiczna'}>
      <Helmet title={"Dermatolog Świdnica - Dent&Beauty | Świdnica"} />
    </OfferBase>
  )
}

export default Offer
